import React from "react";
import { connect } from "react-redux";
import PlayerList from "../playerList";
import _ from "lodash";

const TotLayout = (props) => {
  const { children, gameReducer, paramsReducer, deletePlayer } = props;
  const playersList = _.get(gameReducer, "roomObj.users", []);
  const screenParams = _.get(paramsReducer, "gameObj.screens", {});
  const playersListLabel = _.get(
    screenParams,
    "lobby.players_label",
    "Players"
  );
  return (
    <div className="tot-gp-layout">
      <div className="player-list">
        <PlayerList
          playersList={playersList}
          playersListLabel={playersListLabel}
          deletePlayer={deletePlayer}
        />
      </div>
      <div className="content-col">
        <div className="content-wrapper">{children}</div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
export default connect(mapStateToProps, null)(TotLayout);
